module.exports = __webpack_public_path__ + "static/panda_logo-9108e2ffedf3393e5a9f8713edd1bc9c.png";